import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { removeAfter: { type: Number, default: 3000 } }

  connect() {
    this.timeout = setTimeout(() => this.dismiss(), this.removeAfterValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
    clearTimeout(this.removalTimeout)
  }

  dismiss() {
    clearTimeout(this.timeout)
    this.element.classList.add("translate-y-2", "opacity-0")
    this.removalTimeout = setTimeout(() => this.element.remove(), 200)
  }
}
